import { render, staticRenderFns } from "./WorkExpansionPanelContent.vue?vue&type=template&id=43ec2f0c&scoped=true"
import script from "./WorkExpansionPanelContent.vue?vue&type=script&lang=js"
export * from "./WorkExpansionPanelContent.vue?vue&type=script&lang=js"
import style0 from "./WorkExpansionPanelContent.vue?vue&type=style&index=0&id=43ec2f0c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43ec2f0c",
  null
  
)

export default component.exports